module.exports = __webpack_public_path__ + "31138f6f520a11e570c15116d2859a1f.png";